export function createDiffUtil<T>(keys?: readonly (keyof T)[]) {
	return {
		hasChanges(current: T, baseline: T): boolean {
			const effectiveKeys = keys ?? (Object.keys(current as object) as (keyof T)[]);
			for (const key of effectiveKeys) {
				if (current[key] !== baseline[key]) return true;
			}
			return false;
		},

		diff(current: T, baseline: T): Partial<T> | null {
			const effectiveKeys = keys ?? (Object.keys(current as object) as (keyof T)[]);
			let result: Partial<T> | null = null;

			for (const key of effectiveKeys) {
				if (current[key] !== baseline[key]) {
					if (!result) result = {};
					result[key] = current[key];
				}
			}

			return result;
		},
	};
}